import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-11/task-01";

const task: Slide = {
  title: "Select all true statements about binaural hearing and measurements.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
